import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const {
    creditColumn,
    creditValues,
    dataAction,
    dataType,
    debitColumn,
    debitValues,
    isFractionalUnit,
} = constantsData.forms.dataSources.transform.amount;

const {
    creditColumn: creditColumnFieldName,
    creditValues: creditValuesFieldName,
    dataAction: dataActionFieldName,
    dataType: dataTypeFieldName,
    debitColumn: debitColumnFieldName,
    debitValues: debitValuesFieldName,
    isFractionalUnit: isFractionalUnitFieldName,
} = formFieldNamesData;

export const transformOfflineDataSourceAmountFieldFormData = [
    {
        description: isFractionalUnit.description,
        isOptional: true,
        label: isFractionalUnit.label,
        name: isFractionalUnitFieldName,
        switchLabels: {
            active: constantsData.labels.enabled,
            inactive: constantsData.labels.disabled,
        },
        type: FieldTypeEnum.SWITCH,
    },
    {
        description: dataAction.description,
        hasOptionFormat: true,
        label: dataAction.label,
        name: dataActionFieldName,
        options: optionsData.dataSource.transform.amount.dataActions,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: "allTags",
        description: dataType.description,
        isAsync: true,
        label: dataType.label,
        name: dataTypeFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.CREDITS,
        description: creditValues.description,
        isAsync: true,
        label: creditValues.label,
        name: creditValuesFieldName,
        type: FieldTypeEnum.MULTI_SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.DEBITS,
        description: debitValues.description,
        isAsync: true,
        label: debitValues.label,
        name: debitValuesFieldName,
        type: FieldTypeEnum.MULTI_SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.MAPPED_TAGS,
        description: creditColumn.description,
        isAsync: true,
        label: creditColumn.label,
        name: creditColumnFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.MAPPED_TAGS,
        description: debitColumn.description,
        isAsync: true,
        label: debitColumn.label,
        name: debitColumnFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
